/** [S-802] Which generation a draft card is reporting.
 *
 *  Every card for a draft points at the same draft id, so when a RETRY set that
 *  draft building again the earlier cards followed it too: a draft that failed
 *  ten minutes ago started spinning a second time, beside the card that was
 *  actually running (Diego, live 2026-09-22). A card announces ONE generation —
 *  identified by the build's `startedAt`, carried on the marker — and reports
 *  only that one.
 *
 *  The rule is data in, decision out, so it is read here and nowhere else:
 *  ChatPane's card and its reloaded twin get the same answer. */

export type CardBuild = "building" | "complete" | "failed";

type Marker = { status?: "building"; startedAt?: string };
type Build = { status?: string; startedAt?: string } | null | undefined;

export function draftCardState(
  marker: Marker,
  fetched: Build
): { build: CardBuild; superseded: boolean; mine: boolean } {
  // A marker with no identity is one persisted before we stamped it: it has no
  // way to tell generations apart, so it behaves as it always did.
  const mine =
    marker.startedAt === undefined ||
    fetched?.startedAt === undefined ||
    fetched.startedAt === marker.startedAt;
  const superseded = marker.status === "building" && !mine;
  if (marker.status !== "building" || superseded) return { build: "complete", superseded, mine };
  const status = fetched?.status;
  return {
    build: status === "complete" || status === "failed" ? status : "building",
    superseded,
    mine,
  };
}
